export function Spinner({ size = 'md', className = '' }: { size?: 'sm' | 'md' | 'lg'; className?: string }) {
  return <div className={`spinner spinner--${size} ${className}`} role="status" aria-label="Loading" />;
}
